







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class MemberListIframe extends Vue {
  
  private get remoteSrc() {
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/basic/list?serviceType=PREMIUM';

    return src;
  }
}
